import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            input: {
                pilot: 'update'
            }
        }
    }

    init() {
        this.initVisualizer()
    }

    /**
     * Init sprite data
     *
     * @param
     */
    initVisualizer() {
        this.NB_COLS = parseInt(this.getData('columns'))
        this.NB_ROWS = parseInt(this.getData('rows'))
        this.NB_FRAMES = this.NB_COLS * this.NB_ROWS

        this.FRAME_WIDTH = 100/(this.NB_COLS-1);
        this.FRAME_HEIGHT = 100/(this.NB_ROWS-1 || 1);

        this.getFrameValues()

        gsap.set(this.$('image')[0], { backgroundSize: `${100*this.NB_COLS}% ${100*this.NB_ROWS}%` });

        this.goToFrame(Math.round(this.NB_FRAMES/2))
    }

    /**
     * Set positions data
     *
     * @param
     */
    getFrameValues() {
        this.frames = [];
        for (let i = 0; i < this.NB_FRAMES; i++) {
            let column = i % this.NB_COLS;
            let row = Math.floor(i / this.NB_COLS);

            let frame = { column, row, x: (column * this.FRAME_WIDTH)+'%', y: (row * this.FRAME_HEIGHT)+'%' }
            this.frames.push(frame);
        }
    }

    /**
     * Go to frame
     *
     * @param
     */
    goToFrame(index) {
        gsap.set(this.$('image')[0], { backgroundPosition: `${this.frames[index].x} ${this.frames[index].y}` });
    }

    /**
     * Update
     *
     * @param
     */
    update(e) {
        let progress = parseInt(Math.round(e.curTarget.value * (this.NB_FRAMES - 1) / 100))
        this.goToFrame(progress)
    }
}
